import { env } from '@toggle/helpers';

const hostUrl = new URL(document.URL).origin;

const supportRoot = 'https://support.reflexivity.com/';

export const config = {
  posthog: {
    apiKey: env(
      process.env.PUBLIC_POSTHOG_KEY,
      'phc_fEGrfTrcf1GQsGjyo7lhr6E3bGXqM4NKUugLI9kZaMq'
    ),
    apiHost: env(
      process.env.PUBLIC_POSTHOG_HOST,
      'http://ph.lseg.reflexivity.com/'
    ),
    uiHost: 'https://us.posthog.com',
  },
  app: {
    version: env(process.env.V2_VERSION, ''),
    environment: env(process.env.V2_ENV_LEVEL, 'staging'),
    isLocalEnvironment: hostUrl === 'http://localhost:1234',
    featureFlags: env(process.env.V2_FEATURE_FLAGS, '')?.split(','),
  },
  release: {
    date: env(process.env.V2_RELEASE_DATE, new Date().toISOString()),
    number: env(process.env.V2_RELEASE_NUMBER, '1.1.0'),
  },
  api: {
    root: env(process.env.API_ROOT, `https://api.lseg.rflx.co.uk/`),
    authRoot: env(process.env.AUTH_ROOT, 'https://auth.lseg.rflx.co.uk/'),
    wsRoot: env(process.env.WS_ROOT, 'wss://ws.lseg.rflx.co.uk/'),
  },
  ws: {
    reconnectionLimit: Number(env(process.env.V2_WS_RECONNECTION_LIMIT, '5')),
    reconnectionTimeout: Number(
      env(process.env.V2_WS_RECONNECTION_TIMEOUT, '500')
    ),
    pollingInterval: Number(env(process.env.V2_WS_POLLING_INTERVAL, '5000')),
    connectTimeout: Number(env(process.env.V2_WS_CONNECT_TIMEOUT, '10000')),
  },
  deepLink: {
    ppe: {
      conversation: env(
        process.env.DEEP_LINK_PPE_CONVERSATION,
        'https://workspace.ppe.refinitiv.com/web/rap/deepresearch'
      ),
      entity: env(
        process.env.DEEP_LINK_PPE_ENTITY,
        'https://workspace.ppe.refinitiv.com/web/Apps/Corp/?st=RIC&s='
      ),
      chart: env(
        process.env.DEEP_LINK_PPE_CHART,
        'https://workspace.ppe.refinitiv.com/web/rap/financial-chart/index.html?s='
      ), //multiple rics example LSEG.L&MMM.N&CMG.N&CAVA.K
    },
    prod: {
      conversation: env(
        process.env.DEEP_LINK_PROD_CONVERSATION,
        `https://workspace.refinitiv.com/web/rap/deepresearch`
      ),
      entity: env(
        process.env.DEEP_LINK_PROD_ENTITY,
        'https://workspace.refinitiv.com/web/Apps/Corp/?st=RIC&s='
      ),
      chart: env(
        process.env.DEEP_LINK_PROD_CHART,
        'https://workspace.refinitiv.com/web/rap/financial-chart/index.html?s='
      ),
    },
  },
  urls: {
    root: hostUrl,
    supportRoot,
    webinarLink: env(
      process.env.V2_WEBINAR_LINK,
      'https://us06web.zoom.us/webinar/register/WN_wXeIKzHpT1OvTSAHOziiHQ'
    ),
    supportNewTicket: `${supportRoot}hc/en-us/requests/new`,
    onboardingUrl: 'https://calendar.app.google/2FnsHDLsCwwoTCEW7',
    insightLink: 'https://www.youtube.com/watch?v=yKEaKMUFjHU',
    disclaimerGenAi:
      'https://reflexivity.com/resources/generative-ai-disclaimers-and-notices',
    helpImportWatchlist:
      'https://support.reflexivity.com/hc/en-us/articles/29753957516564-How-to-import-your-watchlist-from-Bloomberg',
    lsegStatement: 'https://www.lseg.com/en/policies/privacy-statement',
    faqs: '/app/static/docs/Workspace Deep Research FAQ 3.pdf',
  },
  ib: {
    website:
      'https://ndcdyn.interactivebrokers.com/sso/Login?action=TA_MARKET_DATA&loginType=1&serviceID1=1357&serviceID2=1064&serviceID3=1065',
    orders: env(
      process.env.V2_IB_ORDERS,
      'https://www.interactivebrokers.com/en/home.php'
    ),
    ibLogin: env(
      process.env.V2_IB_LOGIN,
      'https://www.interactivebrokers.co.uk/sso/Login?action=Settings&config=ResearchSubscriptions'
    ),
    linkDisclaimer: env(
      process.env.V2_IB_LINK_DISCLAIMER,
      'https://support.reflexivity.com/hc/en-us/articles/40656423190548-Important-Disclaimers-about-Direct-Linkage'
    ),
    manageSubscription: env(
      process.env.V2_IB_MANAGE_SUBSCRIPTION,
      'https://ndcdyn.interactivebrokers.com/sso/Login?RL=1&locale=en_US'
    ),
  },
  zendeskEmbedKey: env(
    process.env.V2_ZENDESK_EMBED_KEY,
    'bc557a7c-11a5-450a-a0d0-5a30d21e6288'
  ),
  zendeskSubdomain: env(
    process.env.V2_ZENDESK_SUBDOMAIN,
    'https://toggleglobal.zendesk.com/api/v2/requests'
  ),
  supportUrl: 'https://support.reflexivity.com/hc/en-us/requests/new',
  appStoreLink: env(
    process.env.V2_APP_STORE_LINK,
    'https://apps.apple.com/us/app/toggle-invest-with-confidence/id1537876211'
  ),
  stripePublicKey: env(
    process.env.V2_STRIPE_PUBLIC_KEY,
    'pk_test_51Mdw3pG1Cyr3tMwe60lnBGMRRRlj3ifDQ3wTTdVe2Lz7rIE8aQVg3ntM8wfhtGPyF431iUVl0Yo9k5pnUCdBUZWO00nRitX4J8'
  ),
  ms: {
    teamsParentUrl: env(process.env.TEAMS_PARENT_URL, ''),
  },
  supportEmail: 'WorkspaceChatEAP@lseg.com',
  partnershipsEmail: 'partnerships@reflexivity.com',
  companyDetails: {
    name: 'Knabble, Inc.',
    addressLine1: '460 Broadway',
    addressLine2: 'New York, NY 10036',
  },
};
